import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function detailsButtonClicked({ action, tripId, variant }) {
    const property = { trip_id: tripId };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: variant === 'tripSummary'
            ? 'react_tripsummary'
            : 'react_search',
        label: `${action}_details`,
        property,
    });

    amplitude.track(`${action}_details clicked`, property);
}

function seeMoreFeaturesHovered({ tripId, variant }) {
    const property = { trip_id: tripId };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'hover',
        category: variant === 'tripSummary'
            ? 'react_tripsummary'
            : 'react_search',
        label: 'see_more_amenities',
        property,
    });

    amplitude.track('see_more_amenities hovered', property);
}

function seeMoreFeaturesClicked({ tripId, variant }) {
    const property = { trip_id: tripId };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: variant === 'tripSummary'
            ? 'react_tripsummary'
            : 'react_search',
        label: 'see_more_amenities',
        property,
    });

    amplitude.track('see_more_amenities clicked', property);
}

function policyClicked({ carrierName, tripId, variant }) {
    const property = {
        carrier_name: carrierName,
        trip_id: tripId,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: variant === 'tripSummary'
            ? 'react_tripsummary'
            : 'react_search',
        label: 'covid_policy',
        property,
    });

    amplitude.track('covid_policy clicked', property);
}

function carrierLinkSelected({ carrierName, rating, variant }) {
    const label = rating
        ? 'carrier_rating_link'
        : 'carrier_logo_link';

    const property = { carrier_name: carrierName };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: variant === 'tripSummary'
            ? 'react_tripsummary'
            : 'react_search',
        label,
        property,
    });

    amplitude.track(`${label} clicked`, property);
}

function fareClassSelected({ fareClassCode, fareClassType, tripId }) {
    const property = {
        fare_class_code: fareClassCode,
        fare_class_type: fareClassType,
        trip_id: tripId,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_tripsummary',
        label: 'fare_class_selected',
        property,
    });

    amplitude.track('fare_class_selected clicked', property);
}

export default {
    carrierLinkSelected,
    detailsButtonClicked,
    fareClassSelected,
    policyClicked,
    seeMoreFeaturesClicked,
    seeMoreFeaturesHovered,
};
